import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import LoginForm from './Login/LoginForm';
const LoginPanel = ({ className, successAction, closeAction }) => {
    return (_jsx("div", { className: classnames(className), children: _jsx(LoginForm, { closeAction: closeAction, successAction: successAction }) }));
};
export default LoginPanel;
